import { UserContext } from '../contexts/userContext'
import { useUserState } from './hooks'

/**
 * Provider для управления состоянием пользователя
 */
export function UserProvider({ children }: { children: React.ReactNode }) {
  const userState = useUserState()

  return (
    <UserContext.Provider value={userState}>
      {children}
    </UserContext.Provider>
  )
}